<template>
  <div class="card" v-if="errors.length">
    <div class="card-header">
      <div class="card-header-title">
        Error details
        <button class="download-file" @click="$emit('download-file')">Download</button>
      </div>
    </div>
    <div class="card-body">
      <div class="w-100 custom-border-bottom" v-for="error in errors" :key="error.error_file">
        <div :class="errorLevelColor(error.level)">
          {{ error.level }}:
        </div>
        {{ error.event }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorDetailsTable',
  props: {
    errors: Array
  },
  methods: {
    errorLevelColor (errorLevel) {
      if (errorLevel === 'warning') return 'warning-msg'
      else if (errorLevel === 'error') return 'error-msg'
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../assets/scss/variables';
.error-msg {
  color: $red;
}
.warning-msg {
  color: $orange;
}
.custom-border-bottom {
  border-bottom: 1px solid $pewter;
}
.card-header-title {
  font-size: 24px;
}
.download-file {
  font-size: 15px;
  background-color: #409EFF;
  color: #fff;
  border-radius: .3rem;
  margin-left: 2rem;
  border: 1px solid #409EFF;
  padding: .5rem 1rem;
  &:hover {
    background-color: #66b1ff;
    border: 1px solid #66b1ff;
  }
}
</style>
